import { useTranslation } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { SimpleInput } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

import { Fld, Lbl } from './shared'

const FIELD_COLUMN_NAME_ERROR = 'field-col-name-error'

/**
 * handle create column name field
 */
export function FieldColumnName() {
  const { t } = useTranslation()
  const { id, value, setValue, error, setError } = useCreateColumnContext()
  const { table, gridModal } = useGridV2Context()

  const columnID = gridModal?.column?.id
  const currentColumn = gridModal?.column
  const isProtected =
    !!currentColumn &&
    (currentColumn.type === ColumnTypes.RowID ||
      currentColumn.type === ColumnTypes.SessionID ||
      currentColumn.type === ColumnTypes.Email ||
      ['timestamp', 'email'].includes((currentColumn.name || '').toLowerCase()))

  return (
    <Fld>
      <Lbl>{t('Column Name')}</Lbl>
      <SimpleInput
        placeholder={t('(Optional)')}
        id={`${id}-col-name`}
        error={error[FIELD_COLUMN_NAME_ERROR]}
        value={value.name}
        disabled={isProtected}
        onChange={(e) => {
          if (isProtected) return
          const name = e.currentTarget.value
          const isExists = columnID
            ? table?.columns.find((c) => c.name === name && c.id !== columnID)
            : table?.columns.find((c) => c.name === name)

          if (isExists) {
            setError({
              [FIELD_COLUMN_NAME_ERROR]: t('Column exists'),
            })
          } else {
            setError({
              [FIELD_COLUMN_NAME_ERROR]: undefined,
            })
          }

          setValue({
            name,
          })
        }}
      />
    </Fld>
  )
}
